import { ReactElement } from 'react';

import { appColors, BackrsChip, ContentCompetency } from '@backrs_ui/common-ui';

import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

type CompetencyPageHeaderProps = Readonly<{
  contentCompetency: ContentCompetency;
  categoryName: string;
  handleNavigateToDashboard: () => void;
}>;

export const CompetencyPageHeader = ({
  contentCompetency,
  categoryName,
  handleNavigateToDashboard,
}: CompetencyPageHeaderProps): ReactElement => (
  <Box sx={titleSearchContainerStyle}>
    <Box sx={titleAndPillStyle}>
      <Typography variant="h4" sx={titleStyle}>
        {contentCompetency.title}
      </Typography>
      <Box sx={iconContainerStyle}>
        <BackrsChip
          label={categoryName}
          variant={{ type: 'LARGE_TEXT', backgroundColor: 'GRAY' }}
          onClick={handleNavigateToDashboard}
        />
      </Box>
    </Box>
  </Box>
);

const titleSearchContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  backgroundColor: appColors.color.taupe1,
  marginBottom: 4,
  paddingRight: 4,
  paddingLeft: 3,
  paddingTop: 2,
  paddingBottom: 2,
  borderRadius: '0 0 8px 8px',
  '@media (max-width: 963px)': {
    flexDirection: 'column',
    gap: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  '@media (max-width: 600px)': {
    paddingRight: 2,
  },
};

const iconContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
};

const titleAndPillStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  gap: 3,
  alignItems: 'flex-end',
  marginRight: 3,
  '@media (max-width: 963px)': {
    marginRight: 0,
    flexDirection: 'column',
    alignItems: 'unset',
  },
};

const titleStyle: SxProps<Theme> = {
  fontWeight: 700,
  lineHeight: '36px',
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'flex-end',
  fontFamily: 'Sarabun',
  fontSize: '32px',
  justifyContent: 'flex-end',
  height: '100%',
  marginLeft: 0,
  '@media (max-width: 600px)': {
    alignItems: 'center',
    fontSize: '24px',
    justifyContent: 'center',
  },
};
